<template>
  <div>
    <a-card title="配方及投料记录">
      <a-row :gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px">
          <a-input v-model="searchForm.search" placeholder="编号, 名称, 备注" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px">
          <a-button icon="edit" @click="exportExcels()">导出</a-button>
        </a-col>

        <div style="margin-bottom: 12px; float: right">
          <a-button type="primary" icon="plus" style="margin: 0 8px" @click="openFormModal(form)">新增</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table
                size="small"
                :pagination="pagination"
                :columns="columns"
                :dataSource="items"
                rowKey="id"
                :row-selection="{ onChange: onSelectChange }"
                :expanded-row-keys.sync="expandedRowKeys"
                :loading="loading"
                @change="tableChange"
        >
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{ value ? "激活" : "冻结" }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="edit" size="small" @click="openFormModal(item)">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
              <a-button icon="edit" size="small" @click="exportExcel(item)">导出</a-button>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal
            v-model="visible"
            :form="targetItem"
            :formList2="formList"
            :clientsClassificationOptions="clientsClassificationItems"
            @create="create"
            @update="update"
    />
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div><a-spin style="margin-right: 12px" />正在导入中, 请等待...</div>
    </a-modal>
  </div>
</template>

<script>
  import moment from 'moment';
  import { exportExcel1 } from "@/utils/excel";
  import { saleExport1 } from "@/api/sale";
  import { clientTemplate, clientImport } from "@/api/import";
  import { formulasList, formulasDel } from "@/api/produce";
  export default {
    name: "Warehouse",
    components: {
      FormModal: () => import("./FormModal.vue"),
    },
    data() {
      return {
        formList: [],
        expandedRowKeys: [],
        selectedRowKeys: [],
        columns: [
          {
            title: "编号",
            dataIndex: "number"
          },
          {
            title: "产品编号",
            dataIndex: "product_id",
            customRender: (text) => {
              if (!text) return '';
              return <a-tooltip placement="topLeft" title={text}>
                <span style="display: inline-block; max-width: 50px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {text}
                </span>
              </a-tooltip>;
            }
          },
          {
            title: "产品名称",
            dataIndex: "product_name",
            customRender: (text) => {
              if (!text) return '';
              return <a-tooltip placement="topLeft" title={text}>
                <span style="display: inline-block; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {text}
                </span>
              </a-tooltip>;
            }
          },
          {
            title: "生产日期/批次",
            dataIndex: "batch",
          },
          {
            title: "混合起始时间",
            dataIndex: "start",
            customRender: (text) => {
              if (!text) return '';
              try {
                const formattedDate = moment(text).format('YYYY年MM月DD日 HH:mm:ss');
                return <a-tooltip placement="topLeft" title={formattedDate}>
                  <span style="display: inline-block; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {formattedDate}
                  </span>
                </a-tooltip>;
              } catch (e) {
                console.error('日期格式化错误:', e, text);
                return text;
              }
            }
          },
          {
            title: "混合结束时间",
            dataIndex: "end",
            customRender: (text) => {
              if (!text) return '';
              try {
                const formattedDate = moment(text).format('YYYY年MM月DD日 HH:mm:ss');
                return <a-tooltip placement="topLeft" title={formattedDate}>
                  <span style="display: inline-block; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {formattedDate}
                  </span>
                </a-tooltip>;
              } catch (e) {
                console.error('日期格式化错误:', e, text);
                return text;
              }
            }
          },
          {
            title: "混合均匀情况",
            dataIndex: "situation"
          },
          {
            title: "记录人",
            dataIndex: "recorder"
          },
          {
            title: "复核人",
            dataIndex: "reviewer"
          },
          {
            title: "备注",
            dataIndex: "remark"
          },
          {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" },
            width: "156px",
          },
        ],
        pagination: { current: 1, total: 0, pageSize: 20 },
        searchForm: { search: "", page: 1, page_size: 20 },
        loading: false,
        items: [],
        clientsClassificationItems: [],
        visible: false,
        targetItem: { others: {}, unit: null },
        form: { others: {}, unit: null },
        importLoading: false,
      };
    },
    methods: {
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys
      },
      initialize() {
        this.list();
      },
      list() {
        this.loading = true;
        formulasList(this.searchForm)
                .then((data) => {
                  this.pagination.total = data.count;
                  this.items = data.data;
                })
                .finally(() => {
                  this.loading = false;
                });
      },
      create() {
        this.searchForm.page = 1;
        this.pagination.current = 1;
        this.list();
      },
      update() {
        this.list();
      },
      search() {
        this.pagination.current = 1;
        this.searchForm.page = 1;
        this.list();
      },
      openFormModal(item) {
        const cloned = JSON.parse(JSON.stringify(item))
        // others 后端存的是 JSON 字符串，需要解析成对象
        if (typeof cloned.others === 'string') {
          try { cloned.others = JSON.parse(cloned.others) } catch (e) { cloned.others = {} }
        }
        if (!cloned.others || typeof cloned.others !== 'object') {
          cloned.others = {}
        }
        if (!cloned.others.describe_y) cloned.others.describe_y = []
        if (!cloned.others.describe_s) cloned.others.describe_s = []

        // 新增时默认编号 zcac，用户可修改
        if (!cloned.id && !cloned.number) {
          cloned.number = 'zcac'
        }

        const material = cloned.material
        if (!material || (Array.isArray(material) && material.length === 0)) {
          this.formList = [{ state: "正常", product_name: "", weight: "", material_batch: "", report_img: [] }]
        } else {
          this.formList = []
        }
        this.targetItem = cloned
        this.visible = true;
      },
      destroy(id) {
        formulasDel({ id: id })
                .then((data) => {
                  this.$message.success("删除成功");
                  this.list();
                })
                .finally(() => {
                  this.loading = false;
                });
      },
      async exportExcels() {
        if (this.selectedRowKeys.length === 0) {
          this.$message.warn('请选选择需要导出的数据')
          return;
        }
        const data = await saleExport1({ ids: this.selectedRowKeys, name: 'Formulas', types: 'word' });
        let contentDisposition = data.headers['content-disposition'];
        let regex = /filename\s*=\s*([^;]+)/;
        let matches = contentDisposition && contentDisposition.match(regex);
        let filename = (matches && matches[1].trim()) || '配料表.zip';
        exportExcel1(data.data, filename);
      },
      exportExcel(item) {
        saleExport1({ id: item.id, name: 'Formulas', types: 'word' })
                .then((data) => {
                  let contentDisposition = data.headers['content-disposition'];
                  let regex = /filename\s*=\s*([^;]+)/;
                  let matches = contentDisposition.match(regex);
                  let filename = matches && matches[1].trim();
                  exportExcel1(data.data, filename);
                })
                .catch((err) => {
                  this.$message.error(err.response.data.error);
                });
      },
      downloadTemplate() {
        clientTemplate()
                .then((resp) => {
                  exportExcel(resp.data, "客户导入模板");
                })
                .catch((err) => {
                  this.$message.error(err.response.data.error);
                });
      },
      importExcel(item) {
        let data = new FormData();
        data.append("file", item.file);
        this.importLoading = true;
        setTimeout(() => {
          clientImport(data)
                  .then(() => {
                    this.$message.success("导入成功");
                    this.list();
                  })
                  .catch((err) => {
                    alert("导入错误:" + "\n" + err.response.data.join("\n"));
                  })
                  .finally(() => {
                    this.importLoading = false;
                  });
        }, 1000);
      },
      tableChange(pagination, filters, sorter) {
        this.searchForm.page = pagination.current;
        this.searchForm.page_size = pagination.pageSize;
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        if (sorter && sorter.field) {
          this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
        }
        this.list();
      },
    },
    mounted() {
      this.initialize();
    },
  };
</script>
